// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')

const bem = BemEntity('FeedEmptyMessage')

function createEmptyMessage(template) {
  function EmptyMessage(props) {
    return React.createElement('div', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      template(props)
    )
  }

  EmptyMessage.propTypes = {
    className: PropTypes.string
  }

  return EmptyMessage
}

module.exports = createEmptyMessage
